import { __decorate, __metadata } from "tslib";
import { Component, Emit, Prop, Vue } from "vue-property-decorator";
import Loader from "@/components/widgets/loader.vue";
import { historyDate, lastUpdatedBy, lastUpdatedOn, recordedAt } from "./teamOperationsHelpers";
// What a change that cleared the field reads as
const CLEARED_TEXT = "None";
/**
 * Read-only change history, newest first. Communication shows Media and Frequency in one dialog;
 * Process and Tools show the one field that was opened.
 */
let TeamOperationsFieldHistoryModal = /** @class */ (() => {
    let TeamOperationsFieldHistoryModal = class TeamOperationsFieldHistoryModal extends Vue {
        constructor() {
            super(...arguments);
            this.clearedText = CLEARED_TEXT;
        }
        // "View History - Voice Calls" or "View History - Standup"; Tools keeps its row label
        get modalTitle() {
            const name = (this.label || "").replace(/\s*—\s*/g, " - ");
            return name ? `View History - ${name}` : "View History";
        }
        get grouped() {
            return this.panels.length > 1;
        }
        chipsFor(value) {
            if (!this.multi || !value || value.indexOf(",") === -1) {
                return [];
            }
            return value
                .split(",")
                .map((part) => part.trim())
                .filter((part) => !!part);
        }
        itemsFor(panel) {
            const records = panel.records || [];
            // Newest first by last updated time (the server's order). Only the value each change set is shown;
            // the value before it is the next (older) entry.
            return records.map((record, index) => ({
                key: `${panel.field.attributeId || ""}|${record.createdOn}|${index}`,
                date: historyDate(recordedAt(lastUpdatedOn(record))),
                isCurrent: this.isCurrentRecord(panel.field, record),
                value: record.value || null,
                by: lastUpdatedBy(record),
            }));
        }
        isCurrentRecord(field, record) {
            return !!field.current && field.current.createdOn === record.createdOn;
        }
        close() { }
    };
    __decorate([
        Prop({ default: "" }),
        __metadata("design:type", String)
    ], TeamOperationsFieldHistoryModal.prototype, "label", void 0);
    __decorate([
        Prop({ default: "" }),
        __metadata("design:type", String)
    ], TeamOperationsFieldHistoryModal.prototype, "teamName", void 0);
    __decorate([
        Prop({ default: () => [] }),
        __metadata("design:type", Array)
    ], TeamOperationsFieldHistoryModal.prototype, "panels", void 0);
    __decorate([
        Prop({ default: false }),
        __metadata("design:type", Boolean)
    ], TeamOperationsFieldHistoryModal.prototype, "loading", void 0);
    __decorate([
        Prop({ default: false }),
        __metadata("design:type", Boolean)
    ], TeamOperationsFieldHistoryModal.prototype, "multi", void 0);
    __decorate([
        Emit("close"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], TeamOperationsFieldHistoryModal.prototype, "close", null);
    TeamOperationsFieldHistoryModal = __decorate([
        Component({
            name: "TeamOperationsFieldHistoryModal",
            components: {
                Loader,
            },
        })
    ], TeamOperationsFieldHistoryModal);
    return TeamOperationsFieldHistoryModal;
})();
export default TeamOperationsFieldHistoryModal;
